import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, rem, rgba, spacing, typography, utilityStyles } from '../../styles';
import StyledDropdown from '../dropdown/dropdown.styles';
import StyledDropdownMenu from '../dropdown/styles/dropdown.menu.styles';
import StyledDropdownMenuAffix from '../dropdown/styles/dropdown.menu-affix.styles';
import StyledDropdownMenuBackground from '../dropdown/styles/dropdown.menu-background.styles';
import StyledDropdownMenuWrapper from '../dropdown/styles/dropdown.menu-wrapper.styles';
import StyledAutoCompleteDropdown from '../autocomplete/styles/autocomplete.dropdown.styles';
import StyledAutoCompleteListItem from '../autocomplete/styles/autocomplete.list-item.styles';
import StyledAutoCompleteDropdownInner from '../autocomplete/styles/autocomplete.dropdown-inner.styles';
import StyledMultiSelectAffix from './styles/multi-select.affix.styles';
import StyledDropdownIconContainer from '../dropdown/styles/dropdown.icon-container.styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "107pdsl-defaultStyles",
  styles: "display:none;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1ch9yvl",
  styles: "border-radius:0"
} : {
  name: "1hhbk0c-defaultStyles",
  styles: "border-radius:0;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1ch9yvl",
  styles: "border-radius:0"
} : {
  name: "1hhbk0c-defaultStyles",
  styles: "border-radius:0;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles(_ref4) {
  var disabled = _ref4.disabled,
    hidden = _ref4.hidden,
    isInverse = _ref4.isInverse,
    readOnly = _ref4.readOnly,
    shape = _ref4.shape;
  return /*#__PURE__*/css(StyledDropdownMenuAffix, "{order:unset;position:relative;}", StyledDropdownMenuWrapper, "{align-items:flex-start;display:flex;flex-wrap:wrap;", StyledDropdownMenu, "{border:none;", shape !== 'pill' && _ref3, " flex:1;margin-right:", rem(spacing.spacingControlHeightLg), ";max-width:100%;padding-right:", rem(spacing.spacingControlPad), ";width:100%;}}", StyledDropdownMenuBackground, "{", shape !== 'pill' && _ref2, " cursor:text;&:before{pointer-events:none;}", StyledDropdownIconContainer, "{cursor:default;}}", StyledAutoCompleteDropdown, "{margin:0;width:100%;", StyledAutoCompleteListItem, "{box-shadow:none;&[aria-selected='true']{background:", colors.lightBlue_100, ";}&[disabled]{background:none;color:", rgba(colors.coolGray_900, 0.5), ";cursor:not-allowed;opacity:1;}}", StyledAutoCompleteDropdownInner, "{font-weight:", typography.typographyFontWeightBold, ";}}", disabled && /*#__PURE__*/css("&[disabled]{opacity:1;", StyledDropdownMenuBackground, "{&:before{border-color:", colors.coolGray_500, ";pointer-events:none;}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), " ", hidden && _ref, " ", readOnly && /*#__PURE__*/css(StyledDropdownMenu, "{", isInverse && /*#__PURE__*/css("color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), " padding:0;&:focus{box-shadow:", "".concat(rem(0, 0, 0, 4), " ").concat(colors.lightBlue_500), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var affixSizeStyles = function affixSizeStyles(_ref5) {
  var size = _ref5.size;
  switch (size) {
    case 'sm':
      return /*#__PURE__*/css(StyledMultiSelectAffix, "{padding:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:affixSizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css(StyledDropdownMenuWrapper, "{", StyledDropdownMenu, "{margin-right:", rem(spacing.spacingControlHeightXl), ";}}", StyledMultiSelectAffix, "{padding-top:", rem(8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:affixSizeStyles;"));
  }
};
var dropdownPositionStyles = function dropdownPositionStyles(_ref6) {
  var position = _ref6.position;
  if (position === 'top') {
    return /*#__PURE__*/css(StyledAutoCompleteDropdown, "{bottom:100%;margin-bottom:", rem(5), ";top:unset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownPositionStyles;"));
  } else {
    return /*#__PURE__*/css(StyledAutoCompleteDropdown, "{top:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownPositionStyles;"));
  }
};
var StyledMultiSelect = /*#__PURE__*/_styled(StyledDropdown, process.env.NODE_ENV === "production" ? {
  target: "e127cpnb0"
} : {
  target: "e127cpnb0",
  label: "StyledMultiSelect"
})(defaultStyles, affixSizeStyles, dropdownPositionStyles, utilityStyles);
export default StyledMultiSelect;